webpackJsonp([152254735845807],{

/***/ 1425:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DiscountReasonInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-discount-reason-input-5917864f4b4f8ad77922.js